import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionIdModel } from "./value-addition-id.model";

export class valueAdditionIdResponse extends GlobalResponseObject{

      data?: ValueAdditionIdModel;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionIdModel){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}